import { useTitle } from 'react-use';

import { Layout } from 'CorePackage/MainModule/components/Layout';

import { Reports } from './Reports';

export const ReportsPage = () => {
  useTitle('Отчеты');

  return (
    <Layout withFooter>
      <Reports />
    </Layout>
  );
};
